'use strict';

/**
 * @ngdoc directive
 * @name prepApp.directive:hideableDiv
 * @description
 * # hideableDiv
 */
angular.module('prepApp')
    .directive('hideableDiv', function () {
        return {
            restrict: 'EA',
            scope: {
                hidediv: '='
            },
            replace: true, // Replace with the template below
            transclude: true, // we want to insert custom content inside the directive
            link: function (scope) {
                scope.dialogStyle = {};
                scope.hideModal = function () {
                    scope.hide = true;
                };
            },
            templateUrl: 'views/directives/hideableDiv.html'
        };
    });
